import { render, staticRenderFns } from "./formtreeselect.vue?vue&type=template&id=d310c250"
import script from "./formtreeselect.vue?vue&type=script&lang=js"
export * from "./formtreeselect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports